import {
    OrderStepType,
} from 'app/enums/label.enums'

const transportTypes = [
    'ROAD',
    'AIR',
    'SEA',
]

const isTypeTransport = (stepType: OrderStepType): boolean => {
    return transportTypes.includes(stepType)
}

export default isTypeTransport
